import React, { useState } from "react";
import { sanitizeHtml } from "utils/sanitizeHtml";

const TabcordionTabs = (props) => {
	const {
		toggleState,
		onClick,
		tabs,
		indicatorHeight,
		linksRef,
		animation,
		componentTitle,
		toggle
	} = props;
	const [btnSize, setBtnSize] = useState("reg");
	let buttonText = tabs.map((txt) => {
		return txt.label.length;
	});

	const btnSizer = (txt) => {
		let maxTxt = Math.max(...txt);
		if (maxTxt > 47 && maxTxt <= 55) {
			setBtnSize("large");
		} else if (maxTxt >= 56) {
			setBtnSize("x-large");
		}
	};

	window.addEventListener("load", () => {
		btnSizer(buttonText);
	});

	return (
		<div
			className="tabcordion--flag"
			ref={linksRef}
			role="tablist"
			aria-label={componentTitle + " tablist"}
		>
			{tabs.map((tab) => (
				<button
					key={tab.id}
					className={
						toggleState === tab.id
							? `tabcordion--flag-active ${btnSize} t-body-md-heavy`
							: `tabcordion--flag-inactive ${btnSize} t-body-md-heavy`
					}
					onClick={() => onClick(tab.id, toggle)}
					data-a="true"
					data-a-evt="Subcontent View"
					data-a-comp={componentTitle + " Tabcordion"}
					data-a-text={tab.label}
					role="tab"
					aria-selected={toggleState === tab.id ? "true" : "false"}
					aria-label={tab.label}
					tabIndex={toggleState === tab.id ? "0" : "-1"}
					dangerouslySetInnerHTML={{ __html: sanitizeHtml(tab.label) }}
				></button>
			))}

			<div className={`tabcordion--flag-overhang ${btnSize}`} style={{ top: indicatorHeight }}>
				<div className={`tabcordion--flag-shadow  ${animation} ${btnSize}`}></div>
			</div>
			<div
				className={`goal-flag ${btnSize}`}
				style={{ top: indicatorHeight }}
				id="tabcordion-resize"
			></div>
		</div>
	);
};
export default TabcordionTabs;
